import { Input } from 'components/2-molecules/Inputs/Input';
import { useState } from 'react';
import { ExciseDutyResult, formatCurrency } from '../ExciseDutyResult';
import styles from './DutySettings.module.scss';

export const SpiritsDuty = () => {
	const [alcoholPercentage, setAlcoholPercentage] = useState<number>(null);
	const spiritsRate = 150;
	const rateInfo = `Sats: ${formatCurrency(spiritsRate)} pr. liter (ren alkohol)`;

	const calculator = alcoholPercentage ? (ammount: number) => (((spiritsRate / 100) * alcoholPercentage) / 100) * ammount : null;

	return (
		<>
			<div className={styles.DutySettings}>
				<div>
					<label htmlFor="alcoholPercentage">Alkoholprocent</label>
					<Input
						type="number"
						id="alcoholPercentage"
						appendText="%"
						value={alcoholPercentage?.toString()}
						onChange={(e) => {
							const percentage = e.currentTarget.valueAsNumber;
							setAlcoholPercentage(percentage);
						}}
					/>
				</div>
			</div>
			<ExciseDutyResult unit="cl" container="Flasker" calculator={calculator} rateInfo={rateInfo} />
		</>
	);
};
